"use client";

import { WFPButton } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type AppInformationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

function AppInformationDialog({ open, onOpenChange }: AppInformationDialogProps) {
  const { t } = useTranslation();
  const version = localStorage.getItem("version") || "";
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() || `Invalid date, got: ${currentDate}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("header.appInformation")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3 text-sm">
          <p>{t("header.farm2go")}</p>
          <p>{t("footer.version", { version })}</p>
          <p>{t("footer.text", { currentYear })}</p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <WFPButton variant="outline">{t("common.done")}</WFPButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { AppInformationDialog };
